const LOGIN_HOME = '/login-host';

export const LOGIN_HOST_ROUTES = {
  index: LOGIN_HOME,
};
